const currentUserRoleNames = (currentUserRoleNames = [], action) => {
  switch (action.type) {
    case 'SET_CURRENT_USER_ROLE_NAMES':
      return action.payload
    default:
      return currentUserRoleNames
  }
}
export default currentUserRoleNames
